import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

import {CodeSearchStoreEnum} from '../models/enum/code-search-store.enum';

@Injectable({
  providedIn: 'root'
})
export class CodeSearchStoreService {
  public store: Record<CodeSearchStoreEnum, any> = {
    [CodeSearchStoreEnum.FIREBASE_LOADING_KEY]: '',
    [CodeSearchStoreEnum.TYPE]: '',
    [CodeSearchStoreEnum.CODE_SEARCH_TYPE]: '',
    [CodeSearchStoreEnum.CODE_SEARCH_QUERY]: '',
    [CodeSearchStoreEnum.CODE_SEARCH_RMN]: undefined,
    [CodeSearchStoreEnum.CODE_SEARCH_METADATA_TYPES]: undefined,
    [CodeSearchStoreEnum.CODE_SEARCH_DATA$]: new BehaviorSubject(null),
    [CodeSearchStoreEnum.CODE_SEARCH_TOTAL$]: new BehaviorSubject<number>(0),
    [CodeSearchStoreEnum.CODE_SEARCH_WHERE_TYPES$]: new BehaviorSubject<string>(''),
  };

  public storeFirebaseLoadingKey(refModel: string, type: string): void {
    const key = `/codeSearch/${refModel}`;
    this.set(CodeSearchStoreEnum.FIREBASE_LOADING_KEY, key);
    this.set(CodeSearchStoreEnum.TYPE, type);
  }

  public getFirebaseLoadingKey() {
    return {path: this.get(CodeSearchStoreEnum.FIREBASE_LOADING_KEY), type: this.get(CodeSearchStoreEnum.TYPE)};
  }

  public getCodeSearchType() {
    return this.get(CodeSearchStoreEnum.CODE_SEARCH_TYPE);
  }

  public set(key: CodeSearchStoreEnum, value: any): void {
    this.store[key] = value;
  }

  public get(key: CodeSearchStoreEnum) {
    return this.store[key];
  }

  private verifySubject(key: CodeSearchStoreEnum): void {
    if (!(this.store[key] instanceof BehaviorSubject)) {
      throw new TypeError(
        'CodeSearchStoreService::verivy subject must update key that holds instance of BehaviorSubject'
      );
    }
  }

  public updateSubject(key: CodeSearchStoreEnum, value: any): void {
    this.verifySubject(key);
    this.store[key].next(value);
  }

  public getSubject(key: CodeSearchStoreEnum): Observable<any> {
    this.verifySubject(key);
    return this.store[key].asObservable();
  }

  public updateData(data: any) {
    this.store[CodeSearchStoreEnum.CODE_SEARCH_DATA$].next(data);
  }

  public getData() {
    return this.store[CodeSearchStoreEnum.CODE_SEARCH_DATA$];
  }
}
